jQuery(function ($) {
    // Timing control (ms)
    // Fade duration is controlled in CSS via --hero-fade-duration
    var SLIDE_DURATION = 6000;

    function initHeroCrossfade($hero) {
        var $slides = $hero.find('.block-image');
        if ($slides.length <= 1) {
            // Nothing to rotate
            $slides.addClass('is-active');
            return;
        }

        // ADA: these are decorative background images
        $slides.attr('aria-hidden', 'true');

        // Respect reduced motion
        var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReduced) {
            $slides.removeClass('is-active').eq(0).addClass('is-active');
            return;
        }

        // Allow per-block override via CSS custom properties if you want:
        // e.g. style="--hero-slide-duration: 8000ms"
        var cssDuration = parseInt(
            (getComputedStyle($hero[0]).getPropertyValue('--hero-slide-duration') || '').trim(),
            10
        );
        var duration = Number.isFinite(cssDuration) && cssDuration > 0 ? cssDuration : SLIDE_DURATION;

        var index = 0;
        $slides.removeClass('is-active').eq(index).addClass('is-active');

        // Use a single interval per hero
        var timer = window.setInterval(function () {
            $slides.eq(index).removeClass('is-active');
            index = (index + 1) % $slides.length;
            $slides.eq(index).addClass('is-active');
        }, duration);

        // Optional: pause when tab not visible (saves CPU)
        document.addEventListener('visibilitychange', function () {
            if (document.hidden) {
                window.clearInterval(timer);
            } else {
                // restart cleanly
                timer = window.setInterval(function () {
                    $slides.eq(index).removeClass('is-active');
                    index = (index + 1) % $slides.length;
                    $slides.eq(index).addClass('is-active');
                }, duration);
            }
        });
    }

    $('.wp-block-pulp-hero').each(function () {
        initHeroCrossfade($(this));
    });
});
